import { Image } from '@gitbook/spine-react';

import previewLight from './assets/preview.webp';
import previewDark from './assets/preview-dark.webp';

export function DocsPreview() {
    return (
        <div className="-right-14 relative z-50 flex h-full w-full justify-end">
            <Image
                rounded={false}
                resize={false}
                src={{ light: previewLight, dark: previewDark }}
                alt="Multiple docs example"
                loading="eager"
                fetchPriority="high"
                className="absolute block aspect-[5/6] min-h-dvh w-[45vw]"
            />
        </div>
    );
}
